import Release from '../service/release'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 概况
    getvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.getvendors(payload), {
        type: 'list',
        success,
        fail
      })
    },
    commitwxapp(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.commitwxapp(payload), {
        type: 'action',
        success,
        fail
      })
    },
    wxagetpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.wxagetpage(payload), {
        type: 'info',
        success,
        fail
      })
    },
    wxagetcategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.wxagetcategory(payload), {
        type: 'info',
        success,
        fail
      })
    },
    submitaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.submitaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    librarylist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.librarylist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    releasewxapp(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.releasewxapp(payload), {
        type: 'action',
        success,
        fail
      })
    },
    undocodeaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.undocodeaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    initvendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.initvendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    changeenv(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.changeenv(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getqrcode(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.getqrcode(payload), {
        type: 'blob',
        success,
        fail
      })
    },
    bindtester(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.bindtester(payload), {
        type: 'action',
        success,
        fail
      })
    },
    gettemplatelist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.gettemplatelist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettemplatedraftlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.gettemplatedraftlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addwxapptemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.addwxapptemplate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletewxapptemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Release.deletewxapptemplate(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
